import React from 'react';
import { commitments, images } from '../../data/site';
export function CommitmentsSection() {
  return <section aria-labelledby="commitments-title" className="border-b border-line" data-id="element-71" data-mp="364389nav7l7p">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 py-24 md:px-8 md:py-28 lg:grid-cols-12 lg:items-center" data-id="element-72" data-mp="3b3g4gynmm4my">
        <div className="lg:col-span-5" data-id="element-73" data-mp="3g3c5cp111fya">
          <img src={images.gardener} alt="Jardinier poussant une brouette dans une allée de jardin" className="aspect-[4/5] w-full rounded-lg object-cover" data-id="element-74" data-mp="3g0zgrt0rk7c9" />
        </div>
        <div className="lg:col-span-6 lg:col-start-7" data-id="element-75" data-mp="3p1e756sl4cmm">
          <h2 id="commitments-title" className="font-serif text-4xl font-medium leading-tight text-forest md:text-5xl" data-id="element-76" data-mp="3tvs1r6zfafq8">
            Un artisan local, pas une plateforme
          </h2>
          <p className="mt-5 max-w-lg text-lg leading-relaxed text-ink-muted" data-id="element-77" data-mp="7oabuwm88tvw">
            Je m’occupe de chaque jardin comme si c’était le mien. Voici ce sur quoi vous pouvez
            compter, à chaque intervention.
          </p>
          <dl className="mt-12 grid gap-x-10 gap-y-8 sm:grid-cols-2" data-id="element-78" data-mp="2i1qs8qjse0f1">
            {commitments.map(item => <div key={item.title} className="border-t border-line pt-5" data-id="element-79" data-mp="2d3p802amjv1z">
                <dt className="text-lg font-medium text-ink" data-id="element-80" data-mp="282ronmdvouyw">{item.title}</dt>
                <dd className="mt-2 leading-relaxed text-ink-muted" data-id="element-81" data-mp="234833n375l72">{item.description}</dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}